/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass() 
    export class DesigningItemsDialogForPD extends _Ext.DialogBase<CustomerRequirementItemsRow, any> {
        protected getFormKey() { return CustomerRequirementItemsForm.formKey; }
        protected getIdProperty() { return CustomerRequirementItemsRow.idProperty; }
        protected getLocalTextPrefix() { return CustomerRequirementItemsRow.localTextPrefix; }
        protected getNameProperty() { return CustomerRequirementItemsRow.nameProperty; }
        protected getService() { return CustomerRequirementItemsService.baseUrl; }
        protected getDeletePermission() { return CustomerRequirementItemsRow.deletePermission; }
        protected getInsertPermission() { return CustomerRequirementItemsRow.insertPermission; }
        protected getUpdatePermission() { return CustomerRequirementItemsRow.updatePermission; }
        protected useViewMode() { return true; }
        public form = new CustomerRequirementItemsForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = true;
            return opt;
        }
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public newLineNo: number;
        public Totals: number;
        public HasBom: boolean = true;
        public ItemMaster: CustomerRequirementDialog;
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 250;
            q.initDetailEditor(this, this.form.StoneItems, Config);
            //Make grid full width 
            // **** Assign Values to BOM and Labor Editor ****
            //Set Numeric Fields as Right Align 
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.Budget);
            q.hideEditorLabel(this.form.StoneItems);
            q.hideCaption(this.form.ImageName);
            q.hideCaption(this.form.Image1);
            q.hideCaption(this.form.Image2);
            q.hideCaption(this.form.Image3);
            q.hideCaption(this.form.Image4);
            q.hideCaption(this.form.Image5);
            q.hideCaption(this.form.LedgerName);
 
        }


        protected onDialogOpen() {
            super.onDialogOpen();
            

            //this.form.ItemDetails.setBOMReadOnly();
            //this.form.ItemDetails.setLaborReadOnly(); 
            var type = this.form.ToneType.value;
            if (type == "1") {
                q.hideField(this.form.DualToneKaratId);
                q.hideField(this.form.DualToneMetalColorId);
                q.hideField(this.form.DualToneMetalId);
                q.hideField(this.form.TripleToneKaratId);
                q.hideField(this.form.TripleToneMetalColorId);
                q.hideField(this.form.TripleToneMetalId);
            } else if (type == "2") {

                q.hideField(this.form.TripleToneKaratId);
                q.hideField(this.form.TripleToneMetalColorId);
                q.hideField(this.form.TripleToneMetalId);
            } else if (type == "3") {
                q.showField(this.form.DualToneKaratId);
                q.showField(this.form.DualToneMetalColorId);
                q.showField(this.form.DualToneMetalId);
                q.showField(this.form.TripleToneKaratId);
                q.showField(this.form.TripleToneMetalColorId);
                q.showField(this.form.TripleToneMetalId);
            }
            if (this.form.RefNo.value == "") {
                this.form.StoneCategoryId.ItemTypeId = 105;
                this.form.StoneCategoryId.updateItems();

                //var refno = FormatHelper.GetFormats("RefNo");
                //this.form.RefNo.value = refno;

                Common.CommonService.GetNextNumbers({ Prefix: 'C51000_', Length: 10 }, response => {
                    if (response != null) {
                        this.form.RefNo.value = response.Serial;
                    }
                }, { async: false });
            } else {
                let categoryid = this.form.StoneCategoryId.value;

                this.form.StoneCategoryId.ItemTypeId = 105;
                this.form.StoneCategoryId.updateItems();
                this.form.StoneCategoryId.value = categoryid ;
                var centerstone = this.form.CenterStone.value;
                if (centerstone == "12") {
                    q.showField(this.form.StoneCategoryId);
                    q.showField(this.form.StoneSubCategoryId);
                } else if (centerstone == "11") {
                    q.showField(this.form.StoneCategoryId);
                    q.hideField(this.form.StoneSubCategoryId);
                }
            }
        }
        public getToolbarButtons() {
            return [];
        }

        protected validateBeforeSave() {
            this.form.AttributeId.value = "0";
            if (this.form.RefNo.value == null || this.form.RefNo.value == "") {
                var customercode = this.form.PartyCode.value;
                //Common.CommonService.GetNextNumbers({ Prefix: 'C51000_', Length: 10 }, response => {
                //    if (response != null) {
                //        this.form.RefNo.value = response.Serial;
                //    }
                //}, { async: false });
            }

            var t = this.RateListId;
            this.entity.RefTransId == null ? this.entity.RefTransId = 0 : this.entity.RefTransId = this.entity.RefTransId
            this.entity.RefTransItemId == null ? this.entity.RefTransItemId = 0 : this.entity.RefTransItemId = this.entity.RefTransItemId
            this.entity.RefVoucherId == null ? this.entity.RefVoucherId = 0 : this.entity.RefVoucherId = this.entity.RefVoucherId
            this.entity.Studded == null ? this.entity.Studded = 0 : this.entity.Studded = this.entity.Studded
            this.entity.MetalAmount == null ? this.entity.MetalAmount = 0 : this.entity.MetalAmount = this.entity.MetalAmount
            this.entity.DiamondAmount == null ? this.entity.DiamondAmount = 0 : this.entity.DiamondAmount = this.entity.DiamondAmount
            this.entity.StoneAmount == null ? this.entity.StoneAmount = 0 : this.entity.StoneAmount = this.entity.StoneAmount



            return true;

        }

    }
}